<div class="filter">
  <div class="filter__options">
    <div class="filter__option">
      <input
        class="filter__checkbox"
        type="checkbox"
        value="All"
        (change)="onAllCheckboxChange($event.target.checked)"
        [checked]="isAllChecked$ | async"
      />
      All
    </div>
    <div class="filter__option" *ngFor="let value of values$ | async">
      <input
        class="filter__checkbox"
        type="checkbox"
        value="{{ value }}"
        (change)="onCheckboxChange($event.target.value, $event.target.checked)"
        [checked]="isCheckboxChecked(value) | async"
      />
      {{ value }}
    </div>
  </div>
</div>
